import Types from './types';
import { createReducer } from 'reduxsauce';

const INITIAL_STATE = {
    recentSearch: []
};

const setRecentSearches = (state = INITIAL_STATE, { data }) => {
    return {
        ...state,
        recentSearch: [...state?.recentSearch, data]
    };
};

const HANDLERS = {
    [Types.SET_RECENT_SEARCHES]: setRecentSearches
};

export default createReducer(INITIAL_STATE, HANDLERS);